import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React from 'react';
import 'prop-types';
import styled, { keyframes, css, useTheme } from '@xstyled/styled-components';
import { getVariantColor, clamp } from '@trybeapp/ui.utilities';
import { transparentize } from 'polished';
import { th } from '@xstyled/system';

var _excluded = ["variant"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var spinKeyframes = /*#__PURE__*/keyframes(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n"])));
var animation = /*#__PURE__*/css(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  -webkit-animation: ", " 0.5s linear infinite;\n  animation: ", " 0.5s linear infinite;\n"])), spinKeyframes, spinKeyframes);
var StyledSvg = /*#__PURE__*/styled.svg(function (_ref) {
  var width = _ref.width,
    height = _ref.height,
    value = _ref.value;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    width: ", "};\n    height: ", ";\n    ", "\n  "])), typeof width === 'string' ? width : width + "px", typeof height === 'string' ? height : height + "px", !value && animation);
});
var SpinnerTrack = /*#__PURE__*/styled.path(function (props) {
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  fill-opacity: 0;\n  stroke: ", ";\n"])), transparentize(0.8, th('spinners.default.trackColor')(props)));
});
var SpinnerHead = /*#__PURE__*/styled.path(function (_ref2) {
  var variant = _ref2.variant,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var color = variant ? getVariantColor(variant)(rest) : th('spinners.default.headColor')(rest);
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    fill-opacity: 0;\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transition: stroke-dashoffset 0.2s cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition: stroke-dashoffset 0.2s cubic-bezier(0.4, 1, 0.75, 0.9);\n    stroke: ", ";\n    stroke-linecap: round;\n  "])), transparentize(0.2, color));
});
var R = 45;
var SPINNER_TRACK = "M 50,50 m 0,-" + R + " a " + R + "," + R + " 0 1 1 0," + R * 2 + " a " + R + "," + R + " 0 1 1 0,-" + R * 2;
var PATH_LENGTH = 280;
var MIN_SIZE = 10;
var SIZE_LARGE = 100;
var STROKE_WIDTH = 2;
var MIN_STROKE_WIDTH = 5;
var getSize = function getSize(size, theme) {
  if (typeof size === 'number') {
    return Math.max(MIN_SIZE, size);
  }
  return theme.spinners.sizes[size] || theme.spinners.sizes.lg;
};
var getViewBox = function getViewBox(strokeWidth) {
  var radius = R + strokeWidth / 2;
  var viewBoxX = (50 - radius).toFixed(2);
  var viewBoxWidth = (radius * 2).toFixed(2);
  return viewBoxX + " " + viewBoxX + " " + viewBoxWidth + " " + viewBoxWidth;
};

/**
 * @ref @blueprintjs/core/src/components/spinner/spinner.tsx
 */
var Spinner = function Spinner(_ref3) {
  var size = _ref3.size,
    value = _ref3.value,
    variant = _ref3.variant;
  var theme = useTheme();
  size = getSize(size, theme);
  var strokeWidth = Math.max(MIN_STROKE_WIDTH, STROKE_WIDTH * SIZE_LARGE / size);
  var strokeOffset = PATH_LENGTH - PATH_LENGTH * (value == null ? 0.25 : clamp(value, 0, 1));
  return /*#__PURE__*/React.createElement(StyledSvg, {
    width: size,
    height: size,
    value: value,
    strokeWidth: strokeWidth.toFixed(2),
    viewBox: getViewBox(strokeWidth)
  }, /*#__PURE__*/React.createElement(SpinnerTrack, {
    d: SPINNER_TRACK
  }), /*#__PURE__*/React.createElement(SpinnerHead, {
    variant: variant,
    d: SPINNER_TRACK,
    pathLength: PATH_LENGTH,
    strokeDasharray: PATH_LENGTH + " " + PATH_LENGTH,
    strokeDashoffset: strokeOffset
  }));
};
Spinner.defaultProps = {
  size: 'lg'
};

export { Spinner, SpinnerHead, SpinnerTrack, StyledSvg, spinKeyframes };
